import { userService } from '../services/user.service';
import { useApi } from './use-api';

export function useUsers(clientId: string | undefined) {
  const { loading, result: users, error } = useApi(userService.getList, clientId);
  return { loading, users, error };
}
